import React, { useEffect, useState } from 'react';
import styles from './style.css';
import { MFBeaconButton } from '../Beacon/BeaconComponents';
import checkmark from '../../assets/images/beacon-icon-green-check.svg';
import openNewWindow from '../../assets/images/beacon-icon-open-in-new-window.svg';
import { isTaxable } from '../../flows/shared/utils';

const DocumentsDisclosureRenderer = ({
  accountType,
  setDocsAndDiscClick,
  docsAndDiscClick
}) => {
  const [custAgmtClicked, setCustAgmtClicked] = useState();
  const [iraDiscClicked, setIraDiscClicked] = useState();

  const handleAcctAgmtButtonClick = () => {
    if (isTaxable(accountType)) {
      setDocsAndDiscClick(true);
    } else {
      setCustAgmtClicked(true);
    }

    window.open(
      'https://www.troweprice.com/content/dam/iinvestor/Forms/MFCustomerAccountAgreement.pdf',
      '_blank'
    );
  };

  const handleIRADisclosuresButtonClick = () => {
    setIraDiscClicked(true);
    window.open(
      'https://www.troweprice.com/content/dam/iinvestor/Forms/tradRothIraAgree.pdf',
      '_blank'
    );
  };

  useEffect(() => {
    if (custAgmtClicked && iraDiscClicked) {
      setDocsAndDiscClick(true);
    }
  }, [custAgmtClicked, iraDiscClicked]);

  const buttonLabel = 'Review Customer Account Agreement (PDF)';

  return (
    <div id="finalAgreementTerms" className="final-agreement-terms">
      {!isTaxable(accountType) &&
        (iraDiscClicked ? (
          <MFBeaconButton
            onClick={handleIRADisclosuresButtonClick}
            id="iraDiscOpenedBtn"
            data-name="iraDiscOpenedBtn"
            icon-align="left"
            className="beacon-button-margin-override"
            variant="secondary"
            label="Opened">
            <img
              slot="icon"
              className="success-check-icon"
              src={checkmark}
              alt="Checkmark"
            />
          </MFBeaconButton>
        ) : (
          <MFBeaconButton
            onClick={handleIRADisclosuresButtonClick}
            id="IraDiscBtn"
            data-name="iraDiscBtn"
            icon-align="right"
            variant="secondary"
            className="beacon-button-margin-override"
            label="Review IRA Disclosure Statement and Custodial Agreement (PDF)">
            <img
              className="open-new-window-icon"
              slot="icon"
              src={openNewWindow}
              alt="Open in New Window Icon"
            />
          </MFBeaconButton>
        ))}
      {custAgmtClicked || docsAndDiscClick ? (
        <MFBeaconButton
          onClick={handleAcctAgmtButtonClick}
          id="docsDiscOpenedBtn"
          data-name="docsDiscOpenedBtn"
          icon-align="left"
          variant="secondary"
          className="beacon-button-margin-override"
          label="Opened">
          <img
            slot="icon"
            className="success-check-icon"
            src={checkmark}
            alt="Checkmark"
          />
        </MFBeaconButton>
      ) : (
        <MFBeaconButton
          onClick={handleAcctAgmtButtonClick}
          id="docsDiscBtn"
          data-name="docsDiscBtn"
          icon-align="right"
          className="beacon-button-margin-override"
          variant="secondary"
          label={buttonLabel}>
          <img
            className="open-new-window-icon"
            slot="icon"
            src={openNewWindow}
            alt="Open in New Window Icon"
          />
        </MFBeaconButton>
      )}
      <style jsx>{styles}</style>
    </div>
  );
};

export default DocumentsDisclosureRenderer;
